import { useCallback, useState } from 'react';
import { httpsCallable } from 'firebase/functions';
import { functions } from '../firebase/config';

const callFunction = async (name, payload = {}) => {
  const callable = httpsCallable(functions, name);
  const result = await callable(payload);
  return result.data;
};

const useClassAccess = () => {
  const [loading, setLoading] = useState(false);

  const run = useCallback(async (name, payload) => {
    setLoading(true);
    try {
      return await callFunction(name, payload);
    } finally {
      setLoading(false);
    }
  }, []);

  const listLinks = useCallback(
    (schoolId) => run('listClassAccessLinks', { schoolId }),
    [run]
  );

  const generateLink = useCallback(
    (payload) => run('generateClassAccessLink', payload),
    [run]
  );

  const regenerateLink = useCallback(
    (linkId) => run('regenerateClassAccessLink', { linkId }),
    [run]
  );

  const disableLink = useCallback(
    (linkId) => run('disableClassAccessLink', { linkId }),
    [run]
  );

  const getClassStudents = useCallback(
    (token) => run('getClassStudentsByAccessToken', { token }),
    [run]
  );

  const updateClassStudent = useCallback(
    (token, studentId, updates, photo = null) =>
      run('updateStudentByClassAccessToken', { token, studentId, updates, photo }),
    [run]
  );

  return {
    loading,
    listLinks,
    generateLink,
    regenerateLink,
    disableLink,
    getClassStudents,
    updateClassStudent,
  };
};

export default useClassAccess;
